// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"27af32ce","58":"540167bd","385":"4bc7d2e5","453":"fcdb05a1","487":"b8b0f199","509":"51ea5c74","573":"6ca84827","745":"2bf8c8ff","754":"791190ad","841":"51a094e4","997":"a2f1f028"}[chunkId] + ".chunk.js";
};